module.exports = __webpack_public_path__ + "img/planting_02@2x.9025666.webp";